import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  select: {
    fontSize: '14px',
    boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.3)',
    padding: theme.spacing(1, 2, 1, 2),
    '&:focus': {
      borderRadius: theme.shape.borderRadius
    },
    margin: theme.spacing(0.5, 1, 0.5, 1)
  },
  selectShop: {
    boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.3)',
    padding: theme.spacing(1, 2, 1, 2),
    '&:focus': {
      borderRadius: theme.shape.borderRadius
    },
    margin: theme.spacing(0.5, 1, 0.5, 1)
  },
  inputs: {
    '& > fieldset': {
      border: 'none',
      '&:hover': {
        border: 'none'
      },
      '&:active': {
        border: 'none'
      }
    },
    '&:hover': {
      border: 'none'
    }
  },
  autocompleteInput: {
    padding: '0 !important',
    fontSize: '14px',
    paddingLeft: '6px !important'
  },
  autocompleteRoot: {
    padding: '7px !important'
  },
  label: {
    color: '#a8a6a6',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '17px',
    transform: `translate(14px, -16px) scale(0.75) !important`
  },
  menuPaper: {
    maxHeight: '400px',
    '& > ul': {
      '& > li': {
        fontSize: '14px'
      }
    }
  }
}));
